import { Brand } from '@blade/std-lib'

export const TradeIdTypeId = 'tradebot-tma/TradeId' as const
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TradeIdTypeId = typeof TradeIdTypeId

export type TradeId = Brand.Branded<string, TradeIdTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeId = Brand.nominal<TradeId>()
